export default __webpack_public_path__ + "23f391f815d4442c5136d600a6980b47.jpeg";